class TmlFloatingContact extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.trigger = this.querySelector('[data-contact-trigger]');
    this.panel = this.querySelector('[data-contact-panel]');
    this.closeButton = this.querySelector('[data-contact-close]');

    if (!this.trigger || !this.panel) return;

    this.handleToggle = this.handleToggle.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOutsidePointer = this.handleOutsidePointer.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.trigger.addEventListener('click', this.handleToggle);
    this.closeButton?.addEventListener('click', this.handleClose);
    document.addEventListener('pointerdown', this.handleOutsidePointer);
    document.addEventListener('keydown', this.handleKeydown);

    this.isInitialized = true;
  }

  disconnectedCallback() {
    if (!this.isInitialized) return;

    this.trigger?.removeEventListener('click', this.handleToggle);
    this.closeButton?.removeEventListener('click', this.handleClose);
    document.removeEventListener('pointerdown', this.handleOutsidePointer);
    document.removeEventListener('keydown', this.handleKeydown);

    this.isInitialized = false;
  }

  get isOpen() {
    return this.dataset.open === 'true';
  }

  setOpen(open, restoreFocus = false) {
    this.dataset.open = String(open);
    this.trigger.setAttribute('aria-expanded', String(open));
    this.panel.setAttribute('aria-hidden', String(!open));

    if (open) {
      window.requestAnimationFrame(() => {
        const firstControl = this.panel.querySelector('button, a[href]');
        firstControl?.focus({ preventScroll: true });
      });
    } else if (restoreFocus) {
      this.trigger.focus({ preventScroll: true });
    }
  }

  handleToggle() {
    this.setOpen(!this.isOpen);
  }

  handleClose() {
    this.setOpen(false, true);
  }

  handleOutsidePointer(event) {
    if (this.isOpen && !this.contains(event.target)) {
      this.setOpen(false);

      window.requestAnimationFrame(() => {
        if (this.panel.contains(document.activeElement)) {
          this.trigger.focus({ preventScroll: true });
        }
      });
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault();
      this.setOpen(false, true);
    }
  }
}

if (!customElements.get('tml-floating-contact')) {
  customElements.define('tml-floating-contact', TmlFloatingContact);
}
